import React from 'react';

export const DeadSpaceEdit = (props) => {
  return (
    <>
      <h4>There is no possibility to edit widget yet</h4>
    </>
  );
};
